import { render, staticRenderFns } from "./RegistrationEdit.vue?vue&type=template&id=0d2278c7&"
import script from "./RegistrationEdit.vue?vue&type=script&lang=ts&"
export * from "./RegistrationEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports